import React from "react";
import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";

/**
 * Paragraph (p)
 * */
export const Paragraph = styled.p.attrs(
	({
		center,
		padding,
		maxwidth,
		font,
		color,
		display,
		bold,
		large,
		lineheight,
		margin,
		fontSize,
		fontSizeSmall,
		marginSmall,
		height,
		heightSmall,
		theme,
	}) => ({
		textalign: center ? "center" : "left",
		padding: padding ? "0 .2rem 0 .2rem" : 0,
		maxwidth: maxwidth ? maxwidth : "none",
		font: font ? font : theme.fonts,
		color: color ? color : theme.colors.black,
		display: display ? display : "inline-block",
		fontWeight: bold ? "bold" : "normal",
		fontSize: fontSize ? fontSize : large ? "18px" : "16px",
		smallFontSize: fontSizeSmall ? fontSizeSmall : "16px",
		lineHeight: lineheight ? lineheight : "1.38",
		margin: margin ? margin : 0,
		marginSmall: marginSmall ? marginSmall : 0,
		height: height ? height : "auto",
		heightSmall: heightSmall ? heightSmall : "auto",
	})
)`
	font-family: ${({ font }) => font};
	display: ${({ display }) => display};
	max-width: ${({ maxwidth }) => maxwidth};
	letter-spacing: 0px;
	color: ${({ color }) => color};
	padding: ${({ padding }) => padding};
	text-align: ${({ textalign }) => textalign};
	font-weight: ${({ fontWeight }) => fontWeight};
	font-size: ${({ smallFontSize }) => smallFontSize};
	line-height: ${({ lineHeight }) => lineHeight};
	height: ${({ heightSmall }) => heightSmall};
	margin: ${({ marginSmall }) => marginSmall};

	${media.greaterThan(breakpoints.ipad)`
    	font-size: ${({ fontSize }) => fontSize};
		margin: ${({ margin }) => margin};
		height: ${({ height }) => height};
  `}
`;

/**
 * Ingress (p)
 * */
export const Ingress = styled(Paragraph)`
	font-size: 16px;
	font-weight: ${({ normal }) => (normal ? "normal" : "bold")};
	max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : "")};
	p {
		margin-top: 0;
	}
	a {
		color: ${({ theme }) => theme.colors.primary};
		transition: all 0.2s ease;
		border-bottom: ${({ theme }) => `2px solid ${theme.colors.primary}`};

		:hover,
		:focus {
			transition: all 0.2s ease;
			border-color: ${({ theme }) => theme.colors.none};
			color: ${({ theme }) => theme.colors.secondary};
		}
	}

	${media.greaterThan(breakpoints.ipad)`
		font-size: 18px;
 	`}
`;
export const Bold = styled.span`
	font-size: 16px;
	font-weight: bold;
`;
